/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {TooltipDirective as ɵa} from './lib/_directive/tooltip.directive';